/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminAddManagersToLocationsRequest,
  AdminAddManagersToLocationsResponse,
  AdminAddProToShiftRequest,
  AdminAddProToShiftResponse,
  AdminBulkSetCertificatesQueued,
  AdminBulkSetCertificatesRequest,
  AdminChangeProNameRequest,
  AdminChangeRatingRequest,
  AdminChangeRatingResponse,
  AdminChangeShiftAddressRequest,
  AdminChangeShiftAddressResponse,
  AdminChangeShiftLocationsRequest,
  AdminChangeShiftLocationsResponse,
  AdminCreateBackPayShiftRequest,
  AdminCreateEmployeeInterviewRequest,
  AdminDeleteStripeAccountRequest,
  AdminGigApplication,
  AdminLockGigsRequest,
  AdminMergeUsersRequest,
  AdminMergeUsersResponse,
  AdminProTierBadgeStatus,
  AdminRectifyZealRequest,
  AdminRemoveSuspensionsRequest,
  AdminSetProTierBadgeRequest,
  AdminSetProTierBadgeResponse,
  AdminShiftAddressOptionsResponse,
  AdminSuspension,
  AdminUpdateSuperTokenRequest,
  GigproAdminGrantRequest,
  GigproAdminRead,
  GigproAdminRevokeRequest,
  LogOutAllDevicesRequest,
  NotFoundError,
  RectifyZealResponse,
  ScopedAdminPermissionGrantRequest,
  ScopedAdminPermissionRead,
  ScopedAdminPermissionRevokeRequest,
  ServiceUnavailableError,
  SupportOpsChangeProNameCreate200,
  SupportOpsCreateEmployeeInterviewCreate200,
  SupportOpsDeleteStripeCreate200,
  SupportOpsLocationManager,
  SupportOpsLocationManagersListParams,
  SupportOpsLockGigsCreate202,
  SupportOpsLogOutAllDevicesCreate200,
  SupportOpsProTierBadgeRetrieveParams,
  SupportOpsRerunStatsRetrieve202,
  SupportOpsRerunStatsRetrieveParams,
  SupportOpsShiftAddressOptionsRetrieveParams,
  SupportOpsUpdateSupertokenCreate200
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getSupportOpsAddManagersToLocationsCreateUrl = () => {




  return `/api/support-ops/add-managers-to-locations/`
}

/**
 * Grant existing users manager access directly (no invitation), optionally org-level; partial-success.
 */
export const supportOpsAddManagersToLocationsCreate = async (adminAddManagersToLocationsRequest: AdminAddManagersToLocationsRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminAddManagersToLocationsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminAddManagersToLocationsResponse>(getSupportOpsAddManagersToLocationsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminAddManagersToLocationsRequest)
  }
);}





export const getSupportOpsAddManagersToLocationsCreateMutationKey = () => ['supportOpsAddManagersToLocationsCreate'] as const;

export const getSupportOpsAddManagersToLocationsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsAddManagersToLocationsCreate>>, TError,SupportOpsAddManagersToLocationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportOpsAddManagersToLocationsCreate>>, TError,SupportOpsAddManagersToLocationsCreateMutationVariables, TContext> => {

const mutationKey = getSupportOpsAddManagersToLocationsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportOpsAddManagersToLocationsCreate>>, SupportOpsAddManagersToLocationsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  supportOpsAddManagersToLocationsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SupportOpsAddManagersToLocationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportOpsAddManagersToLocationsCreate>>>
    export type SupportOpsAddManagersToLocationsCreateMutationBody = AdminAddManagersToLocationsRequest
    export type SupportOpsAddManagersToLocationsCreateMutationError = void
    export type SupportOpsAddManagersToLocationsCreateMutationVariables = {data: AdminAddManagersToLocationsRequest}

    export const useSupportOpsAddManagersToLocationsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsAddManagersToLocationsCreate>>, TError,SupportOpsAddManagersToLocationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportOpsAddManagersToLocationsCreate>>,
        TError,
        SupportOpsAddManagersToLocationsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSupportOpsAddManagersToLocationsCreateMutationOptions(options), queryClient);
    }
    export const getSupportOpsAddProToShiftCreateUrl = () => {




  return `/api/support-ops/add-pro-to-shift/`
}

/**
 * Manually confirm one pro onto one or more already-ended shifts so they become payable.
 *
 * Two-step warn/force: a first request (force=False) reports each shift the pro is not fully
 * eligible for as ``requires_force`` with the unmet requirements, writing nothing; a second
 * request with force=True overrides those eligibility gates for a forced add. Confirm-only:
 * does not charge or pay — payment runs separately through the existing Pay Pro dialog. Runs
 * synchronously and returns the per-shift outcome (added / requires_force / skipped) — 200,
 * not 202, because the work is already done on return.
 */
export const supportOpsAddProToShiftCreate = async (adminAddProToShiftRequest: AdminAddProToShiftRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminAddProToShiftResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminAddProToShiftResponse>(getSupportOpsAddProToShiftCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminAddProToShiftRequest)
  }
);}





export const getSupportOpsAddProToShiftCreateMutationKey = () => ['supportOpsAddProToShiftCreate'] as const;

export const getSupportOpsAddProToShiftCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsAddProToShiftCreate>>, TError,SupportOpsAddProToShiftCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportOpsAddProToShiftCreate>>, TError,SupportOpsAddProToShiftCreateMutationVariables, TContext> => {

const mutationKey = getSupportOpsAddProToShiftCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportOpsAddProToShiftCreate>>, SupportOpsAddProToShiftCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  supportOpsAddProToShiftCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SupportOpsAddProToShiftCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportOpsAddProToShiftCreate>>>
    export type SupportOpsAddProToShiftCreateMutationBody = AdminAddProToShiftRequest
    export type SupportOpsAddProToShiftCreateMutationError = void
    export type SupportOpsAddProToShiftCreateMutationVariables = {data: AdminAddProToShiftRequest}

    export const useSupportOpsAddProToShiftCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsAddProToShiftCreate>>, TError,SupportOpsAddProToShiftCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportOpsAddProToShiftCreate>>,
        TError,
        SupportOpsAddProToShiftCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSupportOpsAddProToShiftCreateMutationOptions(options), queryClient);
    }
    export const getSupportOpsBackPayShiftCreateUrl = () => {




  return `/api/support-ops/back-pay-shift/`
}

/**
 * Create an already-worked, unpaid shift with the pro confirmed on it, so it surfaces on the
 * Pay page. Breaks are recorded afterwards through the timesheet break endpoints.
 */
export const supportOpsBackPayShiftCreate = async (adminCreateBackPayShiftRequest: AdminCreateBackPayShiftRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminGigApplication> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminGigApplication>(getSupportOpsBackPayShiftCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminCreateBackPayShiftRequest)
  }
);}





export const getSupportOpsBackPayShiftCreateMutationKey = () => ['supportOpsBackPayShiftCreate'] as const;

export const getSupportOpsBackPayShiftCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsBackPayShiftCreate>>, TError,SupportOpsBackPayShiftCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportOpsBackPayShiftCreate>>, TError,SupportOpsBackPayShiftCreateMutationVariables, TContext> => {

const mutationKey = getSupportOpsBackPayShiftCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportOpsBackPayShiftCreate>>, SupportOpsBackPayShiftCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  supportOpsBackPayShiftCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SupportOpsBackPayShiftCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportOpsBackPayShiftCreate>>>
    export type SupportOpsBackPayShiftCreateMutationBody = AdminCreateBackPayShiftRequest
    export type SupportOpsBackPayShiftCreateMutationError = void
    export type SupportOpsBackPayShiftCreateMutationVariables = {data: AdminCreateBackPayShiftRequest}

    export const useSupportOpsBackPayShiftCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsBackPayShiftCreate>>, TError,SupportOpsBackPayShiftCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportOpsBackPayShiftCreate>>,
        TError,
        SupportOpsBackPayShiftCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSupportOpsBackPayShiftCreateMutationOptions(options), queryClient);
    }
    export const getSupportOpsBulkSetCertificatesCreateUrl = () => {




  return `/api/support-ops/bulk-set-certificates/`
}

/**
 * Bulk-assign skill certificates to pros (every certificate to every pro).
 *
 * Queues a background task and returns an acknowledgement (202). The
 * assignment is idempotent and the worker logs the per-pair outcome
 * (including per-record failures), so re-submit the same request to
 * reconcile any transient failures.
 */
export const supportOpsBulkSetCertificatesCreate = async (adminBulkSetCertificatesRequest: AdminBulkSetCertificatesRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminBulkSetCertificatesQueued> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminBulkSetCertificatesQueued>(getSupportOpsBulkSetCertificatesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminBulkSetCertificatesRequest)
  }
);}





export const getSupportOpsBulkSetCertificatesCreateMutationKey = () => ['supportOpsBulkSetCertificatesCreate'] as const;

export const getSupportOpsBulkSetCertificatesCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsBulkSetCertificatesCreate>>, TError,SupportOpsBulkSetCertificatesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportOpsBulkSetCertificatesCreate>>, TError,SupportOpsBulkSetCertificatesCreateMutationVariables, TContext> => {

const mutationKey = getSupportOpsBulkSetCertificatesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportOpsBulkSetCertificatesCreate>>, SupportOpsBulkSetCertificatesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  supportOpsBulkSetCertificatesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SupportOpsBulkSetCertificatesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportOpsBulkSetCertificatesCreate>>>
    export type SupportOpsBulkSetCertificatesCreateMutationBody = AdminBulkSetCertificatesRequest
    export type SupportOpsBulkSetCertificatesCreateMutationError = void
    export type SupportOpsBulkSetCertificatesCreateMutationVariables = {data: AdminBulkSetCertificatesRequest}

    export const useSupportOpsBulkSetCertificatesCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsBulkSetCertificatesCreate>>, TError,SupportOpsBulkSetCertificatesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportOpsBulkSetCertificatesCreate>>,
        TError,
        SupportOpsBulkSetCertificatesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSupportOpsBulkSetCertificatesCreateMutationOptions(options), queryClient);
    }
    export const getSupportOpsChangeProNameCreateUrl = () => {




  return `/api/support-ops/change-pro-name/`
}

/**
 * Internal support operations tools for GigPro admins.
 *
 * Includes rerunning pro stats, merging duplicate user accounts, deleting
 * Stripe accounts, creating employee interviews, and removing pro suspensions.
 */
export const supportOpsChangeProNameCreate = async (adminChangeProNameRequest: AdminChangeProNameRequest, options?: Parameters<typeof customFetch>[1]): Promise<SupportOpsChangeProNameCreate200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<SupportOpsChangeProNameCreate200>(getSupportOpsChangeProNameCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminChangeProNameRequest)
  }
);}





export const getSupportOpsChangeProNameCreateMutationKey = () => ['supportOpsChangeProNameCreate'] as const;

export const getSupportOpsChangeProNameCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsChangeProNameCreate>>, TError,SupportOpsChangeProNameCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportOpsChangeProNameCreate>>, TError,SupportOpsChangeProNameCreateMutationVariables, TContext> => {

const mutationKey = getSupportOpsChangeProNameCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportOpsChangeProNameCreate>>, SupportOpsChangeProNameCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  supportOpsChangeProNameCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SupportOpsChangeProNameCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportOpsChangeProNameCreate>>>
    export type SupportOpsChangeProNameCreateMutationBody = AdminChangeProNameRequest
    export type SupportOpsChangeProNameCreateMutationError = void
    export type SupportOpsChangeProNameCreateMutationVariables = {data: AdminChangeProNameRequest}

    export const useSupportOpsChangeProNameCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsChangeProNameCreate>>, TError,SupportOpsChangeProNameCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportOpsChangeProNameCreate>>,
        TError,
        SupportOpsChangeProNameCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSupportOpsChangeProNameCreateMutationOptions(options), queryClient);
    }
    export const getSupportOpsChangeRatingCreateUrl = () => {




  return `/api/support-ops/change-rating/`
}

/**
 * Set, create, or clear a pro's business-to-worker star rating for a shift, then refresh
 * the pro's rating summary. A rating of 1-5 sets/creates the review; a null rating clears it.
 */
export const supportOpsChangeRatingCreate = async (adminChangeRatingRequest: AdminChangeRatingRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminChangeRatingResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminChangeRatingResponse>(getSupportOpsChangeRatingCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminChangeRatingRequest)
  }
);}





export const getSupportOpsChangeRatingCreateMutationKey = () => ['supportOpsChangeRatingCreate'] as const;

export const getSupportOpsChangeRatingCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsChangeRatingCreate>>, TError,SupportOpsChangeRatingCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportOpsChangeRatingCreate>>, TError,SupportOpsChangeRatingCreateMutationVariables, TContext> => {

const mutationKey = getSupportOpsChangeRatingCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportOpsChangeRatingCreate>>, SupportOpsChangeRatingCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  supportOpsChangeRatingCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SupportOpsChangeRatingCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportOpsChangeRatingCreate>>>
    export type SupportOpsChangeRatingCreateMutationBody = AdminChangeRatingRequest
    export type SupportOpsChangeRatingCreateMutationError = void
    export type SupportOpsChangeRatingCreateMutationVariables = {data: AdminChangeRatingRequest}

    export const useSupportOpsChangeRatingCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsChangeRatingCreate>>, TError,SupportOpsChangeRatingCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportOpsChangeRatingCreate>>,
        TError,
        SupportOpsChangeRatingCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSupportOpsChangeRatingCreateMutationOptions(options), queryClient);
    }
    export const getSupportOpsChangeShiftAddressCreateUrl = () => {




  return `/api/support-ops/change-shift-address/`
}

/**
 * Reassign shifts to sibling LocationAddresses of the same location.
 */
export const supportOpsChangeShiftAddressCreate = async (adminChangeShiftAddressRequest: AdminChangeShiftAddressRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminChangeShiftAddressResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminChangeShiftAddressResponse>(getSupportOpsChangeShiftAddressCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminChangeShiftAddressRequest)
  }
);}





export const getSupportOpsChangeShiftAddressCreateMutationKey = () => ['supportOpsChangeShiftAddressCreate'] as const;

export const getSupportOpsChangeShiftAddressCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsChangeShiftAddressCreate>>, TError,SupportOpsChangeShiftAddressCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportOpsChangeShiftAddressCreate>>, TError,SupportOpsChangeShiftAddressCreateMutationVariables, TContext> => {

const mutationKey = getSupportOpsChangeShiftAddressCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportOpsChangeShiftAddressCreate>>, SupportOpsChangeShiftAddressCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  supportOpsChangeShiftAddressCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SupportOpsChangeShiftAddressCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportOpsChangeShiftAddressCreate>>>
    export type SupportOpsChangeShiftAddressCreateMutationBody = AdminChangeShiftAddressRequest
    export type SupportOpsChangeShiftAddressCreateMutationError = void
    export type SupportOpsChangeShiftAddressCreateMutationVariables = {data: AdminChangeShiftAddressRequest}

    export const useSupportOpsChangeShiftAddressCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsChangeShiftAddressCreate>>, TError,SupportOpsChangeShiftAddressCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportOpsChangeShiftAddressCreate>>,
        TError,
        SupportOpsChangeShiftAddressCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSupportOpsChangeShiftAddressCreateMutationOptions(options), queryClient);
    }
    export const getSupportOpsChangeShiftLocationsCreateUrl = () => {




  return `/api/support-ops/change-shift-locations/`
}

/**
 * Move one or more shifts (gigs) to a different location, re-deriving location-stamped fields;
 * any shift can move and only hard integrity constraints fail a shift, surfaced per shift.
 */
export const supportOpsChangeShiftLocationsCreate = async (adminChangeShiftLocationsRequest: AdminChangeShiftLocationsRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminChangeShiftLocationsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminChangeShiftLocationsResponse>(getSupportOpsChangeShiftLocationsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminChangeShiftLocationsRequest)
  }
);}





export const getSupportOpsChangeShiftLocationsCreateMutationKey = () => ['supportOpsChangeShiftLocationsCreate'] as const;

export const getSupportOpsChangeShiftLocationsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsChangeShiftLocationsCreate>>, TError,SupportOpsChangeShiftLocationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportOpsChangeShiftLocationsCreate>>, TError,SupportOpsChangeShiftLocationsCreateMutationVariables, TContext> => {

const mutationKey = getSupportOpsChangeShiftLocationsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportOpsChangeShiftLocationsCreate>>, SupportOpsChangeShiftLocationsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  supportOpsChangeShiftLocationsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SupportOpsChangeShiftLocationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportOpsChangeShiftLocationsCreate>>>
    export type SupportOpsChangeShiftLocationsCreateMutationBody = AdminChangeShiftLocationsRequest
    export type SupportOpsChangeShiftLocationsCreateMutationError = void
    export type SupportOpsChangeShiftLocationsCreateMutationVariables = {data: AdminChangeShiftLocationsRequest}

    export const useSupportOpsChangeShiftLocationsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsChangeShiftLocationsCreate>>, TError,SupportOpsChangeShiftLocationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportOpsChangeShiftLocationsCreate>>,
        TError,
        SupportOpsChangeShiftLocationsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSupportOpsChangeShiftLocationsCreateMutationOptions(options), queryClient);
    }
    export const getSupportOpsCreateEmployeeInterviewCreateUrl = () => {




  return `/api/support-ops/create-employee-interview/`
}

/**
 * Create or update employee interviews for multiple pros.
 */
export const supportOpsCreateEmployeeInterviewCreate = async (adminCreateEmployeeInterviewRequest: AdminCreateEmployeeInterviewRequest, options?: Parameters<typeof customFetch>[1]): Promise<SupportOpsCreateEmployeeInterviewCreate200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<SupportOpsCreateEmployeeInterviewCreate200>(getSupportOpsCreateEmployeeInterviewCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminCreateEmployeeInterviewRequest)
  }
);}





export const getSupportOpsCreateEmployeeInterviewCreateMutationKey = () => ['supportOpsCreateEmployeeInterviewCreate'] as const;

export const getSupportOpsCreateEmployeeInterviewCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsCreateEmployeeInterviewCreate>>, TError,SupportOpsCreateEmployeeInterviewCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportOpsCreateEmployeeInterviewCreate>>, TError,SupportOpsCreateEmployeeInterviewCreateMutationVariables, TContext> => {

const mutationKey = getSupportOpsCreateEmployeeInterviewCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportOpsCreateEmployeeInterviewCreate>>, SupportOpsCreateEmployeeInterviewCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  supportOpsCreateEmployeeInterviewCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SupportOpsCreateEmployeeInterviewCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportOpsCreateEmployeeInterviewCreate>>>
    export type SupportOpsCreateEmployeeInterviewCreateMutationBody = AdminCreateEmployeeInterviewRequest
    export type SupportOpsCreateEmployeeInterviewCreateMutationError = void
    export type SupportOpsCreateEmployeeInterviewCreateMutationVariables = {data: AdminCreateEmployeeInterviewRequest}

    export const useSupportOpsCreateEmployeeInterviewCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsCreateEmployeeInterviewCreate>>, TError,SupportOpsCreateEmployeeInterviewCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportOpsCreateEmployeeInterviewCreate>>,
        TError,
        SupportOpsCreateEmployeeInterviewCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSupportOpsCreateEmployeeInterviewCreateMutationOptions(options), queryClient);
    }
    export const getSupportOpsDeleteStripeCreateUrl = () => {




  return `/api/support-ops/delete-stripe/`
}

/**
 * Delete a Stripe connected account after verifying zero balance.
 */
export const supportOpsDeleteStripeCreate = async (adminDeleteStripeAccountRequest: AdminDeleteStripeAccountRequest, options?: Parameters<typeof customFetch>[1]): Promise<SupportOpsDeleteStripeCreate200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<SupportOpsDeleteStripeCreate200>(getSupportOpsDeleteStripeCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminDeleteStripeAccountRequest)
  }
);}





export const getSupportOpsDeleteStripeCreateMutationKey = () => ['supportOpsDeleteStripeCreate'] as const;

export const getSupportOpsDeleteStripeCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsDeleteStripeCreate>>, TError,SupportOpsDeleteStripeCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportOpsDeleteStripeCreate>>, TError,SupportOpsDeleteStripeCreateMutationVariables, TContext> => {

const mutationKey = getSupportOpsDeleteStripeCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportOpsDeleteStripeCreate>>, SupportOpsDeleteStripeCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  supportOpsDeleteStripeCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SupportOpsDeleteStripeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportOpsDeleteStripeCreate>>>
    export type SupportOpsDeleteStripeCreateMutationBody = AdminDeleteStripeAccountRequest
    export type SupportOpsDeleteStripeCreateMutationError = void
    export type SupportOpsDeleteStripeCreateMutationVariables = {data: AdminDeleteStripeAccountRequest}

    export const useSupportOpsDeleteStripeCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsDeleteStripeCreate>>, TError,SupportOpsDeleteStripeCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportOpsDeleteStripeCreate>>,
        TError,
        SupportOpsDeleteStripeCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSupportOpsDeleteStripeCreateMutationOptions(options), queryClient);
    }
    export const getSupportOpsGigproAdminsListUrl = () => {




  return `/api/support-ops/gigpro-admins/`
}

/**
 * List every user who holds gigpro-admin status, derived from the authoritative
 * ``User.is_gigpro_admin`` flag; the active audit row is left-joined for metadata where one
 * exists, so a Django-admin-granted user with no row still appears (null id/granted_at).
 */
export const supportOpsGigproAdminsList = async ( options?: Parameters<typeof customFetch>[1]): Promise<GigproAdminRead[]> => {

  return customFetch<GigproAdminRead[]>(getSupportOpsGigproAdminsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSupportOpsGigproAdminsListQueryKey = () => {
    return [
    `/api/support-ops/gigpro-admins/`
    ] as const;
    }


export const getSupportOpsGigproAdminsListQueryOptions = <TData = Awaited<ReturnType<typeof supportOpsGigproAdminsList>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsGigproAdminsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportOpsGigproAdminsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportOpsGigproAdminsList>>> = ({ signal }) => supportOpsGigproAdminsList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportOpsGigproAdminsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportOpsGigproAdminsListQueryResult = NonNullable<Awaited<ReturnType<typeof supportOpsGigproAdminsList>>>
export type SupportOpsGigproAdminsListQueryError = void


export function useSupportOpsGigproAdminsList<TData = Awaited<ReturnType<typeof supportOpsGigproAdminsList>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsGigproAdminsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportOpsGigproAdminsList>>,
          TError,
          Awaited<ReturnType<typeof supportOpsGigproAdminsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportOpsGigproAdminsList<TData = Awaited<ReturnType<typeof supportOpsGigproAdminsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsGigproAdminsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportOpsGigproAdminsList>>,
          TError,
          Awaited<ReturnType<typeof supportOpsGigproAdminsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportOpsGigproAdminsList<TData = Awaited<ReturnType<typeof supportOpsGigproAdminsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsGigproAdminsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportOpsGigproAdminsList<TData = Awaited<ReturnType<typeof supportOpsGigproAdminsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsGigproAdminsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportOpsGigproAdminsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSupportOpsGigproAdminsGrantCreateUrl = () => {




  return `/api/support-ops/gigpro-admins/grant/`
}

/**
 * Grant gigpro-admin status to one or more users.
 */
export const supportOpsGigproAdminsGrantCreate = async (gigproAdminGrantRequest: GigproAdminGrantRequest, options?: Parameters<typeof customFetch>[1]): Promise<GigproAdminRead[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<GigproAdminRead[]>(getSupportOpsGigproAdminsGrantCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(gigproAdminGrantRequest)
  }
);}





export const getSupportOpsGigproAdminsGrantCreateMutationKey = () => ['supportOpsGigproAdminsGrantCreate'] as const;

export const getSupportOpsGigproAdminsGrantCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsGigproAdminsGrantCreate>>, TError,SupportOpsGigproAdminsGrantCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportOpsGigproAdminsGrantCreate>>, TError,SupportOpsGigproAdminsGrantCreateMutationVariables, TContext> => {

const mutationKey = getSupportOpsGigproAdminsGrantCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportOpsGigproAdminsGrantCreate>>, SupportOpsGigproAdminsGrantCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  supportOpsGigproAdminsGrantCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SupportOpsGigproAdminsGrantCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportOpsGigproAdminsGrantCreate>>>
    export type SupportOpsGigproAdminsGrantCreateMutationBody = GigproAdminGrantRequest
    export type SupportOpsGigproAdminsGrantCreateMutationError = void
    export type SupportOpsGigproAdminsGrantCreateMutationVariables = {data: GigproAdminGrantRequest}

    export const useSupportOpsGigproAdminsGrantCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsGigproAdminsGrantCreate>>, TError,SupportOpsGigproAdminsGrantCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportOpsGigproAdminsGrantCreate>>,
        TError,
        SupportOpsGigproAdminsGrantCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSupportOpsGigproAdminsGrantCreateMutationOptions(options), queryClient);
    }
    export const getSupportOpsGigproAdminsRevokeCreateUrl = () => {




  return `/api/support-ops/gigpro-admins/revoke/`
}

/**
 * Revoke gigpro-admin status from one or more users.
 */
export const supportOpsGigproAdminsRevokeCreate = async (gigproAdminRevokeRequest: GigproAdminRevokeRequest, options?: Parameters<typeof customFetch>[1]): Promise<GigproAdminRead[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<GigproAdminRead[]>(getSupportOpsGigproAdminsRevokeCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(gigproAdminRevokeRequest)
  }
);}





export const getSupportOpsGigproAdminsRevokeCreateMutationKey = () => ['supportOpsGigproAdminsRevokeCreate'] as const;

export const getSupportOpsGigproAdminsRevokeCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsGigproAdminsRevokeCreate>>, TError,SupportOpsGigproAdminsRevokeCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportOpsGigproAdminsRevokeCreate>>, TError,SupportOpsGigproAdminsRevokeCreateMutationVariables, TContext> => {

const mutationKey = getSupportOpsGigproAdminsRevokeCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportOpsGigproAdminsRevokeCreate>>, SupportOpsGigproAdminsRevokeCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  supportOpsGigproAdminsRevokeCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SupportOpsGigproAdminsRevokeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportOpsGigproAdminsRevokeCreate>>>
    export type SupportOpsGigproAdminsRevokeCreateMutationBody = GigproAdminRevokeRequest
    export type SupportOpsGigproAdminsRevokeCreateMutationError = void
    export type SupportOpsGigproAdminsRevokeCreateMutationVariables = {data: GigproAdminRevokeRequest}

    export const useSupportOpsGigproAdminsRevokeCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsGigproAdminsRevokeCreate>>, TError,SupportOpsGigproAdminsRevokeCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportOpsGigproAdminsRevokeCreate>>,
        TError,
        SupportOpsGigproAdminsRevokeCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSupportOpsGigproAdminsRevokeCreateMutationOptions(options), queryClient);
    }
    export const getSupportOpsLocationManagersListUrl = (params: SupportOpsLocationManagersListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/support-ops/location-managers/?${stringifiedParams}` : `/api/support-ops/location-managers/`
}

/**
 * List a destination location's selectable on-site managers, for the move MOD dropdown.
 */
export const supportOpsLocationManagersList = async (params: SupportOpsLocationManagersListParams, options?: Parameters<typeof customFetch>[1]): Promise<SupportOpsLocationManager[]> => {

  return customFetch<SupportOpsLocationManager[]>(getSupportOpsLocationManagersListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSupportOpsLocationManagersListQueryKey = (params?: SupportOpsLocationManagersListParams,) => {
    return [
    `/api/support-ops/location-managers/`, ...(params ? [params] : [])
    ] as const;
    }


export const getSupportOpsLocationManagersListQueryOptions = <TData = Awaited<ReturnType<typeof supportOpsLocationManagersList>>, TError = void>(params: SupportOpsLocationManagersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsLocationManagersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportOpsLocationManagersListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportOpsLocationManagersList>>> = ({ signal }) => supportOpsLocationManagersList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportOpsLocationManagersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportOpsLocationManagersListQueryResult = NonNullable<Awaited<ReturnType<typeof supportOpsLocationManagersList>>>
export type SupportOpsLocationManagersListQueryError = void


export function useSupportOpsLocationManagersList<TData = Awaited<ReturnType<typeof supportOpsLocationManagersList>>, TError = void>(
 params: SupportOpsLocationManagersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsLocationManagersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportOpsLocationManagersList>>,
          TError,
          Awaited<ReturnType<typeof supportOpsLocationManagersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportOpsLocationManagersList<TData = Awaited<ReturnType<typeof supportOpsLocationManagersList>>, TError = void>(
 params: SupportOpsLocationManagersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsLocationManagersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportOpsLocationManagersList>>,
          TError,
          Awaited<ReturnType<typeof supportOpsLocationManagersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportOpsLocationManagersList<TData = Awaited<ReturnType<typeof supportOpsLocationManagersList>>, TError = void>(
 params: SupportOpsLocationManagersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsLocationManagersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportOpsLocationManagersList<TData = Awaited<ReturnType<typeof supportOpsLocationManagersList>>, TError = void>(
 params: SupportOpsLocationManagersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsLocationManagersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportOpsLocationManagersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSupportOpsLockGigsCreateUrl = () => {




  return `/api/support-ops/lock-gigs/`
}

/**
 * Lock gigs by cancelling unconfirmed applications and disabling auto-select.
 */
export const supportOpsLockGigsCreate = async (adminLockGigsRequest: AdminLockGigsRequest, options?: Parameters<typeof customFetch>[1]): Promise<SupportOpsLockGigsCreate202> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<SupportOpsLockGigsCreate202>(getSupportOpsLockGigsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminLockGigsRequest)
  }
);}





export const getSupportOpsLockGigsCreateMutationKey = () => ['supportOpsLockGigsCreate'] as const;

export const getSupportOpsLockGigsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsLockGigsCreate>>, TError,SupportOpsLockGigsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportOpsLockGigsCreate>>, TError,SupportOpsLockGigsCreateMutationVariables, TContext> => {

const mutationKey = getSupportOpsLockGigsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportOpsLockGigsCreate>>, SupportOpsLockGigsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  supportOpsLockGigsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SupportOpsLockGigsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportOpsLockGigsCreate>>>
    export type SupportOpsLockGigsCreateMutationBody = AdminLockGigsRequest
    export type SupportOpsLockGigsCreateMutationError = void
    export type SupportOpsLockGigsCreateMutationVariables = {data: AdminLockGigsRequest}

    export const useSupportOpsLockGigsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsLockGigsCreate>>, TError,SupportOpsLockGigsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportOpsLockGigsCreate>>,
        TError,
        SupportOpsLockGigsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSupportOpsLockGigsCreateMutationOptions(options), queryClient);
    }
    export const getSupportOpsLogOutAllDevicesCreateUrl = () => {




  return `/api/support-ops/log-out-all-devices/`
}

/**
 * Revoke every active session of any user (pro or manager).
 */
export const supportOpsLogOutAllDevicesCreate = async (logOutAllDevicesRequest: LogOutAllDevicesRequest, options?: Parameters<typeof customFetch>[1]): Promise<SupportOpsLogOutAllDevicesCreate200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<SupportOpsLogOutAllDevicesCreate200>(getSupportOpsLogOutAllDevicesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(logOutAllDevicesRequest)
  }
);}





export const getSupportOpsLogOutAllDevicesCreateMutationKey = () => ['supportOpsLogOutAllDevicesCreate'] as const;

export const getSupportOpsLogOutAllDevicesCreateMutationOptions = <TError = void | NotFoundError | ServiceUnavailableError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsLogOutAllDevicesCreate>>, TError,SupportOpsLogOutAllDevicesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportOpsLogOutAllDevicesCreate>>, TError,SupportOpsLogOutAllDevicesCreateMutationVariables, TContext> => {

const mutationKey = getSupportOpsLogOutAllDevicesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportOpsLogOutAllDevicesCreate>>, SupportOpsLogOutAllDevicesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  supportOpsLogOutAllDevicesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SupportOpsLogOutAllDevicesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportOpsLogOutAllDevicesCreate>>>
    export type SupportOpsLogOutAllDevicesCreateMutationBody = LogOutAllDevicesRequest
    export type SupportOpsLogOutAllDevicesCreateMutationError = void | NotFoundError | ServiceUnavailableError
    export type SupportOpsLogOutAllDevicesCreateMutationVariables = {data: LogOutAllDevicesRequest}

    export const useSupportOpsLogOutAllDevicesCreate = <TError = void | NotFoundError | ServiceUnavailableError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsLogOutAllDevicesCreate>>, TError,SupportOpsLogOutAllDevicesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportOpsLogOutAllDevicesCreate>>,
        TError,
        SupportOpsLogOutAllDevicesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSupportOpsLogOutAllDevicesCreateMutationOptions(options), queryClient);
    }
    export const getSupportOpsMergeUsersCreateUrl = () => {




  return `/api/support-ops/merge-users/`
}

/**
 * Merge multiple user accounts into one.
 */
export const supportOpsMergeUsersCreate = async (adminMergeUsersRequest: AdminMergeUsersRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminMergeUsersResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminMergeUsersResponse>(getSupportOpsMergeUsersCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminMergeUsersRequest)
  }
);}





export const getSupportOpsMergeUsersCreateMutationKey = () => ['supportOpsMergeUsersCreate'] as const;

export const getSupportOpsMergeUsersCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsMergeUsersCreate>>, TError,SupportOpsMergeUsersCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportOpsMergeUsersCreate>>, TError,SupportOpsMergeUsersCreateMutationVariables, TContext> => {

const mutationKey = getSupportOpsMergeUsersCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportOpsMergeUsersCreate>>, SupportOpsMergeUsersCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  supportOpsMergeUsersCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SupportOpsMergeUsersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportOpsMergeUsersCreate>>>
    export type SupportOpsMergeUsersCreateMutationBody = AdminMergeUsersRequest
    export type SupportOpsMergeUsersCreateMutationError = void
    export type SupportOpsMergeUsersCreateMutationVariables = {data: AdminMergeUsersRequest}

    export const useSupportOpsMergeUsersCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsMergeUsersCreate>>, TError,SupportOpsMergeUsersCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportOpsMergeUsersCreate>>,
        TError,
        SupportOpsMergeUsersCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSupportOpsMergeUsersCreateMutationOptions(options), queryClient);
    }
    export const getSupportOpsPermissionsListUrl = () => {




  return `/api/support-ops/permissions/`
}

/**
 * List every active scoped-admin grant, for the granter roster view.
 */
export const supportOpsPermissionsList = async ( options?: Parameters<typeof customFetch>[1]): Promise<ScopedAdminPermissionRead[]> => {

  return customFetch<ScopedAdminPermissionRead[]>(getSupportOpsPermissionsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSupportOpsPermissionsListQueryKey = () => {
    return [
    `/api/support-ops/permissions/`
    ] as const;
    }


export const getSupportOpsPermissionsListQueryOptions = <TData = Awaited<ReturnType<typeof supportOpsPermissionsList>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsPermissionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportOpsPermissionsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportOpsPermissionsList>>> = ({ signal }) => supportOpsPermissionsList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportOpsPermissionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportOpsPermissionsListQueryResult = NonNullable<Awaited<ReturnType<typeof supportOpsPermissionsList>>>
export type SupportOpsPermissionsListQueryError = void


export function useSupportOpsPermissionsList<TData = Awaited<ReturnType<typeof supportOpsPermissionsList>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsPermissionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportOpsPermissionsList>>,
          TError,
          Awaited<ReturnType<typeof supportOpsPermissionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportOpsPermissionsList<TData = Awaited<ReturnType<typeof supportOpsPermissionsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsPermissionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportOpsPermissionsList>>,
          TError,
          Awaited<ReturnType<typeof supportOpsPermissionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportOpsPermissionsList<TData = Awaited<ReturnType<typeof supportOpsPermissionsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsPermissionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportOpsPermissionsList<TData = Awaited<ReturnType<typeof supportOpsPermissionsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsPermissionsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportOpsPermissionsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSupportOpsPermissionsGrantCreateUrl = () => {




  return `/api/support-ops/permissions/grant/`
}

/**
 * Grant a scoped-admin permission to one or more users.
 */
export const supportOpsPermissionsGrantCreate = async (scopedAdminPermissionGrantRequest: ScopedAdminPermissionGrantRequest, options?: Parameters<typeof customFetch>[1]): Promise<ScopedAdminPermissionRead[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ScopedAdminPermissionRead[]>(getSupportOpsPermissionsGrantCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(scopedAdminPermissionGrantRequest)
  }
);}





export const getSupportOpsPermissionsGrantCreateMutationKey = () => ['supportOpsPermissionsGrantCreate'] as const;

export const getSupportOpsPermissionsGrantCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsPermissionsGrantCreate>>, TError,SupportOpsPermissionsGrantCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportOpsPermissionsGrantCreate>>, TError,SupportOpsPermissionsGrantCreateMutationVariables, TContext> => {

const mutationKey = getSupportOpsPermissionsGrantCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportOpsPermissionsGrantCreate>>, SupportOpsPermissionsGrantCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  supportOpsPermissionsGrantCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SupportOpsPermissionsGrantCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportOpsPermissionsGrantCreate>>>
    export type SupportOpsPermissionsGrantCreateMutationBody = ScopedAdminPermissionGrantRequest
    export type SupportOpsPermissionsGrantCreateMutationError = void
    export type SupportOpsPermissionsGrantCreateMutationVariables = {data: ScopedAdminPermissionGrantRequest}

    export const useSupportOpsPermissionsGrantCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsPermissionsGrantCreate>>, TError,SupportOpsPermissionsGrantCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportOpsPermissionsGrantCreate>>,
        TError,
        SupportOpsPermissionsGrantCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSupportOpsPermissionsGrantCreateMutationOptions(options), queryClient);
    }
    export const getSupportOpsPermissionsRevokeCreateUrl = () => {




  return `/api/support-ops/permissions/revoke/`
}

/**
 * Revoke a scoped-admin permission from one or more users.
 */
export const supportOpsPermissionsRevokeCreate = async (scopedAdminPermissionRevokeRequest: ScopedAdminPermissionRevokeRequest, options?: Parameters<typeof customFetch>[1]): Promise<ScopedAdminPermissionRead[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ScopedAdminPermissionRead[]>(getSupportOpsPermissionsRevokeCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(scopedAdminPermissionRevokeRequest)
  }
);}





export const getSupportOpsPermissionsRevokeCreateMutationKey = () => ['supportOpsPermissionsRevokeCreate'] as const;

export const getSupportOpsPermissionsRevokeCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsPermissionsRevokeCreate>>, TError,SupportOpsPermissionsRevokeCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportOpsPermissionsRevokeCreate>>, TError,SupportOpsPermissionsRevokeCreateMutationVariables, TContext> => {

const mutationKey = getSupportOpsPermissionsRevokeCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportOpsPermissionsRevokeCreate>>, SupportOpsPermissionsRevokeCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  supportOpsPermissionsRevokeCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SupportOpsPermissionsRevokeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportOpsPermissionsRevokeCreate>>>
    export type SupportOpsPermissionsRevokeCreateMutationBody = ScopedAdminPermissionRevokeRequest
    export type SupportOpsPermissionsRevokeCreateMutationError = void
    export type SupportOpsPermissionsRevokeCreateMutationVariables = {data: ScopedAdminPermissionRevokeRequest}

    export const useSupportOpsPermissionsRevokeCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsPermissionsRevokeCreate>>, TError,SupportOpsPermissionsRevokeCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportOpsPermissionsRevokeCreate>>,
        TError,
        SupportOpsPermissionsRevokeCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSupportOpsPermissionsRevokeCreateMutationOptions(options), queryClient);
    }
    export const getSupportOpsProTierBadgeRetrieveUrl = (params: SupportOpsProTierBadgeRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/support-ops/pro-tier-badge/?${stringifiedParams}` : `/api/support-ops/pro-tier-badge/`
}

/**
 * A pro's active and scheduled tier medal, plus the tier their current monthly stats qualify for.
 */
export const supportOpsProTierBadgeRetrieve = async (params: SupportOpsProTierBadgeRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<AdminProTierBadgeStatus> => {

  return customFetch<AdminProTierBadgeStatus>(getSupportOpsProTierBadgeRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSupportOpsProTierBadgeRetrieveQueryKey = (params?: SupportOpsProTierBadgeRetrieveParams,) => {
    return [
    `/api/support-ops/pro-tier-badge/`, ...(params ? [params] : [])
    ] as const;
    }


export const getSupportOpsProTierBadgeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof supportOpsProTierBadgeRetrieve>>, TError = void>(params: SupportOpsProTierBadgeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsProTierBadgeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportOpsProTierBadgeRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportOpsProTierBadgeRetrieve>>> = ({ signal }) => supportOpsProTierBadgeRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportOpsProTierBadgeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportOpsProTierBadgeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof supportOpsProTierBadgeRetrieve>>>
export type SupportOpsProTierBadgeRetrieveQueryError = void


export function useSupportOpsProTierBadgeRetrieve<TData = Awaited<ReturnType<typeof supportOpsProTierBadgeRetrieve>>, TError = void>(
 params: SupportOpsProTierBadgeRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsProTierBadgeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportOpsProTierBadgeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportOpsProTierBadgeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportOpsProTierBadgeRetrieve<TData = Awaited<ReturnType<typeof supportOpsProTierBadgeRetrieve>>, TError = void>(
 params: SupportOpsProTierBadgeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsProTierBadgeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportOpsProTierBadgeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportOpsProTierBadgeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportOpsProTierBadgeRetrieve<TData = Awaited<ReturnType<typeof supportOpsProTierBadgeRetrieve>>, TError = void>(
 params: SupportOpsProTierBadgeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsProTierBadgeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportOpsProTierBadgeRetrieve<TData = Awaited<ReturnType<typeof supportOpsProTierBadgeRetrieve>>, TError = void>(
 params: SupportOpsProTierBadgeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsProTierBadgeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportOpsProTierBadgeRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSupportOpsRectifyZealCreateUrl = () => {




  return `/api/support-ops/rectify-zeal/`
}

/**
 * Preview or execute Zeal employee record rectification.
 *
 * Two modes controlled by the `confirm` field:
 * - confirm=false (default): Preview — returns user/Zeal info, PII match status, and planned changes.
 * - confirm=true: Execute — applies rectification changes.
 */
export const supportOpsRectifyZealCreate = async (adminRectifyZealRequest: AdminRectifyZealRequest, options?: Parameters<typeof customFetch>[1]): Promise<RectifyZealResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<RectifyZealResponse>(getSupportOpsRectifyZealCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminRectifyZealRequest)
  }
);}





export const getSupportOpsRectifyZealCreateMutationKey = () => ['supportOpsRectifyZealCreate'] as const;

export const getSupportOpsRectifyZealCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsRectifyZealCreate>>, TError,SupportOpsRectifyZealCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportOpsRectifyZealCreate>>, TError,SupportOpsRectifyZealCreateMutationVariables, TContext> => {

const mutationKey = getSupportOpsRectifyZealCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportOpsRectifyZealCreate>>, SupportOpsRectifyZealCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  supportOpsRectifyZealCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SupportOpsRectifyZealCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportOpsRectifyZealCreate>>>
    export type SupportOpsRectifyZealCreateMutationBody = AdminRectifyZealRequest
    export type SupportOpsRectifyZealCreateMutationError = void
    export type SupportOpsRectifyZealCreateMutationVariables = {data: AdminRectifyZealRequest}

    export const useSupportOpsRectifyZealCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsRectifyZealCreate>>, TError,SupportOpsRectifyZealCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportOpsRectifyZealCreate>>,
        TError,
        SupportOpsRectifyZealCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSupportOpsRectifyZealCreateMutationOptions(options), queryClient);
    }
    export const getSupportOpsRemoveSuspensionsCreateUrl = () => {




  return `/api/support-ops/remove-suspensions/`
}

/**
 * Delete suspensions related to a user profile
 */
export const supportOpsRemoveSuspensionsCreate = async (adminRemoveSuspensionsRequest: AdminRemoveSuspensionsRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminSuspension[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminSuspension[]>(getSupportOpsRemoveSuspensionsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminRemoveSuspensionsRequest)
  }
);}





export const getSupportOpsRemoveSuspensionsCreateMutationKey = () => ['supportOpsRemoveSuspensionsCreate'] as const;

export const getSupportOpsRemoveSuspensionsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsRemoveSuspensionsCreate>>, TError,SupportOpsRemoveSuspensionsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportOpsRemoveSuspensionsCreate>>, TError,SupportOpsRemoveSuspensionsCreateMutationVariables, TContext> => {

const mutationKey = getSupportOpsRemoveSuspensionsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportOpsRemoveSuspensionsCreate>>, SupportOpsRemoveSuspensionsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  supportOpsRemoveSuspensionsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SupportOpsRemoveSuspensionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportOpsRemoveSuspensionsCreate>>>
    export type SupportOpsRemoveSuspensionsCreateMutationBody = AdminRemoveSuspensionsRequest
    export type SupportOpsRemoveSuspensionsCreateMutationError = void
    export type SupportOpsRemoveSuspensionsCreateMutationVariables = {data: AdminRemoveSuspensionsRequest}

    export const useSupportOpsRemoveSuspensionsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsRemoveSuspensionsCreate>>, TError,SupportOpsRemoveSuspensionsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportOpsRemoveSuspensionsCreate>>,
        TError,
        SupportOpsRemoveSuspensionsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSupportOpsRemoveSuspensionsCreateMutationOptions(options), queryClient);
    }
    export const getSupportOpsRerunStatsRetrieveUrl = (params?: SupportOpsRerunStatsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/support-ops/rerun-stats/?${stringifiedParams}` : `/api/support-ops/rerun-stats/`
}

/**
 * Reruns pro stats
 */
export const supportOpsRerunStatsRetrieve = async (params?: SupportOpsRerunStatsRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<SupportOpsRerunStatsRetrieve202> => {

  return customFetch<SupportOpsRerunStatsRetrieve202>(getSupportOpsRerunStatsRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSupportOpsRerunStatsRetrieveQueryKey = (params?: SupportOpsRerunStatsRetrieveParams,) => {
    return [
    `/api/support-ops/rerun-stats/`, ...(params ? [params] : [])
    ] as const;
    }


export const getSupportOpsRerunStatsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof supportOpsRerunStatsRetrieve>>, TError = void>(params?: SupportOpsRerunStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsRerunStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportOpsRerunStatsRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportOpsRerunStatsRetrieve>>> = ({ signal }) => supportOpsRerunStatsRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportOpsRerunStatsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportOpsRerunStatsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof supportOpsRerunStatsRetrieve>>>
export type SupportOpsRerunStatsRetrieveQueryError = void


export function useSupportOpsRerunStatsRetrieve<TData = Awaited<ReturnType<typeof supportOpsRerunStatsRetrieve>>, TError = void>(
 params: undefined |  SupportOpsRerunStatsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsRerunStatsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportOpsRerunStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportOpsRerunStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportOpsRerunStatsRetrieve<TData = Awaited<ReturnType<typeof supportOpsRerunStatsRetrieve>>, TError = void>(
 params?: SupportOpsRerunStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsRerunStatsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportOpsRerunStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportOpsRerunStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportOpsRerunStatsRetrieve<TData = Awaited<ReturnType<typeof supportOpsRerunStatsRetrieve>>, TError = void>(
 params?: SupportOpsRerunStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsRerunStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportOpsRerunStatsRetrieve<TData = Awaited<ReturnType<typeof supportOpsRerunStatsRetrieve>>, TError = void>(
 params?: SupportOpsRerunStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsRerunStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportOpsRerunStatsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSupportOpsSetProTierBadgeCreateUrl = () => {




  return `/api/support-ops/set-pro-tier-badge/`
}

/**
 * Grant a pro a tier medal valid through the end of next month, replacing any other active tier.
 */
export const supportOpsSetProTierBadgeCreate = async (adminSetProTierBadgeRequest: AdminSetProTierBadgeRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminSetProTierBadgeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminSetProTierBadgeResponse>(getSupportOpsSetProTierBadgeCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminSetProTierBadgeRequest)
  }
);}





export const getSupportOpsSetProTierBadgeCreateMutationKey = () => ['supportOpsSetProTierBadgeCreate'] as const;

export const getSupportOpsSetProTierBadgeCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsSetProTierBadgeCreate>>, TError,SupportOpsSetProTierBadgeCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportOpsSetProTierBadgeCreate>>, TError,SupportOpsSetProTierBadgeCreateMutationVariables, TContext> => {

const mutationKey = getSupportOpsSetProTierBadgeCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportOpsSetProTierBadgeCreate>>, SupportOpsSetProTierBadgeCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  supportOpsSetProTierBadgeCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SupportOpsSetProTierBadgeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportOpsSetProTierBadgeCreate>>>
    export type SupportOpsSetProTierBadgeCreateMutationBody = AdminSetProTierBadgeRequest
    export type SupportOpsSetProTierBadgeCreateMutationError = void
    export type SupportOpsSetProTierBadgeCreateMutationVariables = {data: AdminSetProTierBadgeRequest}

    export const useSupportOpsSetProTierBadgeCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsSetProTierBadgeCreate>>, TError,SupportOpsSetProTierBadgeCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportOpsSetProTierBadgeCreate>>,
        TError,
        SupportOpsSetProTierBadgeCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSupportOpsSetProTierBadgeCreateMutationOptions(options), queryClient);
    }
    export const getSupportOpsShiftAddressOptionsRetrieveUrl = (params: SupportOpsShiftAddressOptionsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/support-ops/shift-address-options/?${stringifiedParams}` : `/api/support-ops/shift-address-options/`
}

/**
 * Get available address options for reassigning shifts.
 */
export const supportOpsShiftAddressOptionsRetrieve = async (params: SupportOpsShiftAddressOptionsRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<AdminShiftAddressOptionsResponse> => {

  return customFetch<AdminShiftAddressOptionsResponse>(getSupportOpsShiftAddressOptionsRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSupportOpsShiftAddressOptionsRetrieveQueryKey = (params?: SupportOpsShiftAddressOptionsRetrieveParams,) => {
    return [
    `/api/support-ops/shift-address-options/`, ...(params ? [params] : [])
    ] as const;
    }


export const getSupportOpsShiftAddressOptionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof supportOpsShiftAddressOptionsRetrieve>>, TError = void>(params: SupportOpsShiftAddressOptionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsShiftAddressOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportOpsShiftAddressOptionsRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportOpsShiftAddressOptionsRetrieve>>> = ({ signal }) => supportOpsShiftAddressOptionsRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportOpsShiftAddressOptionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportOpsShiftAddressOptionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof supportOpsShiftAddressOptionsRetrieve>>>
export type SupportOpsShiftAddressOptionsRetrieveQueryError = void


export function useSupportOpsShiftAddressOptionsRetrieve<TData = Awaited<ReturnType<typeof supportOpsShiftAddressOptionsRetrieve>>, TError = void>(
 params: SupportOpsShiftAddressOptionsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsShiftAddressOptionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportOpsShiftAddressOptionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportOpsShiftAddressOptionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportOpsShiftAddressOptionsRetrieve<TData = Awaited<ReturnType<typeof supportOpsShiftAddressOptionsRetrieve>>, TError = void>(
 params: SupportOpsShiftAddressOptionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsShiftAddressOptionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportOpsShiftAddressOptionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportOpsShiftAddressOptionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportOpsShiftAddressOptionsRetrieve<TData = Awaited<ReturnType<typeof supportOpsShiftAddressOptionsRetrieve>>, TError = void>(
 params: SupportOpsShiftAddressOptionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsShiftAddressOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportOpsShiftAddressOptionsRetrieve<TData = Awaited<ReturnType<typeof supportOpsShiftAddressOptionsRetrieve>>, TError = void>(
 params: SupportOpsShiftAddressOptionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportOpsShiftAddressOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportOpsShiftAddressOptionsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSupportOpsUpdateSupertokenCreateUrl = () => {




  return `/api/support-ops/update-supertoken/`
}

/**
 * Update SuperTokens phone number for a given user. TODO: Add support for email
 */
export const supportOpsUpdateSupertokenCreate = async (adminUpdateSuperTokenRequest: AdminUpdateSuperTokenRequest, options?: Parameters<typeof customFetch>[1]): Promise<SupportOpsUpdateSupertokenCreate200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<SupportOpsUpdateSupertokenCreate200>(getSupportOpsUpdateSupertokenCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminUpdateSuperTokenRequest)
  }
);}





export const getSupportOpsUpdateSupertokenCreateMutationKey = () => ['supportOpsUpdateSupertokenCreate'] as const;

export const getSupportOpsUpdateSupertokenCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsUpdateSupertokenCreate>>, TError,SupportOpsUpdateSupertokenCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportOpsUpdateSupertokenCreate>>, TError,SupportOpsUpdateSupertokenCreateMutationVariables, TContext> => {

const mutationKey = getSupportOpsUpdateSupertokenCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportOpsUpdateSupertokenCreate>>, SupportOpsUpdateSupertokenCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  supportOpsUpdateSupertokenCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SupportOpsUpdateSupertokenCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportOpsUpdateSupertokenCreate>>>
    export type SupportOpsUpdateSupertokenCreateMutationBody = AdminUpdateSuperTokenRequest
    export type SupportOpsUpdateSupertokenCreateMutationError = void
    export type SupportOpsUpdateSupertokenCreateMutationVariables = {data: AdminUpdateSuperTokenRequest}

    export const useSupportOpsUpdateSupertokenCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportOpsUpdateSupertokenCreate>>, TError,SupportOpsUpdateSupertokenCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportOpsUpdateSupertokenCreate>>,
        TError,
        SupportOpsUpdateSupertokenCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSupportOpsUpdateSupertokenCreateMutationOptions(options), queryClient);
    }
